import { Permission } from "./Permission";

export class RoleDto {
  private id?: number;
  private description?: string;
  private roleName?: string;
  private roleType?: number;
  private status: number = 1;
  private versionId: number = 1;
  private permissions: Permission[] = [];
  private permissionsStr?: string;

  constructor(init?: Partial<RoleDto>) {
    Object.assign(this, init);
  }

  // ✅ Getters
  getId(): number | undefined {
    return this.id;
  }

  getDescription(): string | undefined {
    return this.description;
  }

  getRoleName(): string | undefined {
    return this.roleName;
  }

  getRoleType(): number | undefined {
    return this.roleType;
  }

  getStatus(): number {
    return this.status;
  }

  getVersionId(): number {
    return this.versionId;
  }

  getPermissions(): Permission[] {
    return this.permissions;
  }

  getPermissionsStr(): string | undefined {
    return this.permissionsStr;
  }

  // ✅ Setters
  setId(value: number): void {
    this.id = value;
  }

  setDescription(value: string): void {
    this.description = value;
  }

  setRoleName(value: string): void {
    if (!value) throw new Error("Role Name can't be empty");
    this.roleName = value;
  }

  setRoleType(value: number): void {
    this.roleType = value;
  }

  setStatus(value: number): void {
    this.status = value;
  }

  setVersionId(value: number): void {
    this.versionId = value;
  }

  setPermissions(value: Permission[]): void {
    if (!value || value.length === 0)
      throw new Error("Permissions can't be empty");
    this.permissions = value;
  }

  setPermissionsStr(value: string): void {
    this.permissionsStr = value;
  }
}
